var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurchase = function SvgPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    fill: "none",
    viewBox: "0 0 74 74"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EDF0",
    d: "M12.138 9.742h49.455v6.761H12.138z",
    className: "icon-color-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.054 17.073h60.134v3.528H7.054z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBF1F1",
    d: "M12.137 20.031h49.832v41.971H12.137z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.821 20.031h48.772v41.617H12.821z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF9F9",
    d: "M12.821 41.319h48.772v20.329H12.821z",
    className: "icon-color-1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FCFC",
    d: "M31.756 20.646H61.97v14.027H31.756z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C5CFD5",
    strokeLinecap: "round",
    strokeWidth: 1.347,
    d: "m48.611 25.894-3.574 3.627m-.817-3.878-3.574 3.627m12.356-3.125-3.574 3.627",
    className: "icon-color-3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EDF0",
    d: "M48.241 34.745h4.609v33.55h-4.609z",
    className: "icon-color-4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFDADF",
    d: "M31.898 45.428h11.085v16.22H31.898z",
    className: "icon-color-5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.91 38.431H39.197l-.297 8.63h22.713l5.554-4.464z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#788D94",
    fillRule: "evenodd",
    d: "m62.715 47.21 4.89-3.502a1.2 1.2 0 0 0 .05-1.914l-5-3.993h.06V21.46h4.07a1.5 1.5 0 0 0 1.5-1.5v-2.49a1.5 1.5 0 0 0-1.5-1.5h-4.07v-5.655a1.5 1.5 0 0 0-1.5-1.5H12.97a1.5 1.5 0 0 0-1.5 1.5v5.655H7.42a1.5 1.5 0 0 0-1.5 1.5v2.49a1.5 1.5 0 0 0 1.5 1.5h4.05v39.404H6.845v1.85h40.44v4.81h-4.64v1.85H58.46v-1.85h-4.61v-4.81h13.51v-1.85h-4.645zm-1.382-1.287H39.84v-6.746h21.57l4.21 3.364a.2.2 0 0 1-.008.319zM52 37.127a.2.2 0 0 1-.2.2h-2.465a.2.2 0 0 1-.2-.2v-1.57c0-.11.09-.2.2-.2H51.8c.11 0 .2.09.2.2zm1.85-.682h7.015v.882H53.85zm7.015-1.85H53.85c0-.6-.487-1.088-1.088-1.088h-4.389c-.6 0-1.088.487-1.088 1.088H32.699V21.46h28.166zm-13.58 1.85v.882h-9.296v3.313H13.32V21.46h17.53v14.985zM41.72 47.774v13.091H32.7V46.187h5.29v1.587h3.731zM13.32 10.87c0-.11.09-.2.2-.2h47.145c.11 0 .2.09.2.2v5.104H13.32zm-5.35 8.74a.2.2 0 0 1-.2-.2v-1.39c0-.11.09-.2.2-.2h58.265c.11 0 .2.09.2.2v1.39a.2.2 0 0 1-.2.2zm5.35 22.88h24.669v1.85h-7.14v16.525h-17.53zm30.25 18.375V47.774h3.715v13.091zm5.565 6.66V47.774h2.864v19.751zm11.73-19.751v13.091h-7.016V47.773z",
    className: "icon-stroke-fill",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#788D94",
    strokeWidth: 1.6,
    d: "M17.156 25.1h9.9v11.909h-9.9z",
    className: "icon-stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5F6",
    d: "m27.29 30.442-10.138 2.145.012 4.304h10.125z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#788D94",
    strokeWidth: 1.6,
    d: "M17.156 25.1h9.9v11.909h-9.9z",
    className: "icon-stroke"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.356 45.511h11.5v12.335h-11.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5F6",
    d: "m27.29 50.288-10.138 2.145.012 4.304h10.125z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#788D94",
    strokeWidth: 1.6,
    d: "M17.156 46.311h9.9v10.735h-9.9z",
    className: "icon-stroke"
  })));
};
export default SvgPurchase;